if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.form = document.getElementById(`product-form-${this.sectionId}`);
        if (!this.mainButton || !this.form || !('IntersectionObserver' in window)) {
          this.remove();
          return;
        }

        this.button = this.querySelector('[data-sticky-button]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.variantEl = this.querySelector('[data-sticky-variant]');
        this.hidden = false;
        this.setVisible(false);

        // 本体の購入ボタンが見えているあいだは隠す
        this.intersection = new IntersectionObserver((entries) => {
          this.setVisible(!entries[0].isIntersecting);
        });
        this.intersection.observe(this.mainButton);

        // 売り切れ・ボタン文言を本体と合わせる
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        this.syncButton();

        // バリエーションを変えたら価格と名前を合わせる
        const priceSource = document.getElementById(`price-${this.sectionId}`);
        if (priceSource && this.priceEl) {
          this.priceObserver = new MutationObserver(() => this.syncPrice(priceSource));
          this.priceObserver.observe(priceSource, { childList: true, subtree: true, characterData: true });
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event.data || event.data.sectionId !== this.sectionId) return;
            if (this.variantEl && event.data.variant) this.variantEl.textContent = event.data.variant.title;
          });
        }

        this.onResize = () => this.updateHeight();
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        this.intersection?.disconnect();
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        document.body.classList.remove('sticky-atc-visible');
      }

      setVisible(show) {
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-visible', show);
        if (show) this.updateHeight();
      }

      updateHeight() {
        document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      }

      syncButton() {
        const unavailable =
          this.mainButton.hasAttribute('disabled') || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = unavailable && !this.mainButton.classList.contains('loading');
        const label = this.mainButton.querySelector('span:not(.hidden)');
        if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();
      }

      syncPrice(priceSource) {
        const current =
          priceSource.querySelector('.price--on-sale .price-item--sale') ||
          priceSource.querySelector('.price__regular .price-item--regular');
        if (current && current.textContent.trim()) this.priceEl.textContent = current.textContent.trim();
      }
    }
  );
}
